var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222,
    height: 234,
    viewBox: "0 0 157.000000 152.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,152.000000) scale(0.100000,-0.100000)",
    fill: "#FF002B",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184 1450 c-54 -22 -54 -20 -54 -487 l0 -432 24 -28 c24 -28 25 -28 143 -28 98 0 118 3 118 15 0 12 -20 15 -110 18 -98 2 -112 5 -127 23 -17 19 -18 55 -18 433 0 356 2 415 16 434 l15 22 568 0 c537 0 569 -1 584 -18 15 -17 17 -62 17 -439 0 -391 -1 -421 -18 -436 -14 -12 -43 -17 -127 -19 -90 -2 -110 -6 -110 -18 0 -12 20 -16 105 -18 61 -2 115 2 131 9 57 23 59 38 59 484 0 443 -2 459 -56 484 -30 13 -1127 15 -1160 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 1345 c-4 -10 -1 -21 7 -26 20 -12 34 -5 34 17 0 24 -33 31 -41 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 1349 c-8 -14 21 -43 35 -35 6 4 11 16 11 27 0 21 -34 27 -46 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 1341 c0 -26 17 -36 35 -21 18 15 8 40 -16 40 -12 0 -19 -7 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 1249 c-4 -6 -3 -15 2 -20 5 -5 225 -8 539 -7 462 3 529 5 529 18 0 13 -67 15 -532 18 -377 1 -534 -1 -538 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 1106 c-17 -8 -34 -21 -38 -31 -3 -9 -6 -220 -6 -469 l0 -453 23 -21 c22 -21 31 -22 234 -22 116 0 219 3 228 6 43 17 45 40 45 503 l0 440 -24 28 -24 28 -204 2 c-155 2 -210 0 -234 -11z m434 -38 c9 -9 12 -109 12 -390 l0 -378 -230 0 -230 0 0 372 c0 332 2 373 17 390 15 16 35 18 218 18 143 0 204 -3 213 -12z m12 -852 c0 -75 -3 -76 -227 -76 -226 0 -233 2 -233 77 l0 43 230 0 230 0 0 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 827 l-77 -19 0 -100 c0 -120 12 -145 93 -201 29 -20 57 -37 61 -37 17 0 118 86 132 111 9 19 14 60 14 127 l0 99 -73 19 c-72 19 -74 19 -150 1z m146 -38 l47 -11 0 -75 c0 -89 -13 -117 -74 -161 l-46 -33 -44 33 c-24 18 -49 42 -56 52 -18 28 -26 171 -10 181 21 13 104 33 120 29 8 -1 36 -8 63 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781 695 c-35 -32 -44 -35 -56 -25 -12 10 -19 10 -28 1 -9 -9 -5 -18 16 -38 l27 -28 52 52 c39 39 49 56 41 64 -8 8 -22 1 -52 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 216 c-14 -17 -4 -26 30 -26 25 0 47 15 37 25 -11 11 -58 12 -67 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.f3429bc7440653d14c49277c66cce0bf.svg";
export { ForwardRef as ReactComponent };